export enum PageType {
    PDP = 'PDP',
}
